<template>
  <v-app>
    <div id="app">
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>
  // Set up the ag grid enterprise configurations
  // commit to push
  import { LicenseManager } from 'ag-grid-enterprise'
  LicenseManager.setLicenseKey(
    'Turner_MultiApp_16Devs_2Deployment_13_August_2020__MTU5NzI3MzIwMDAwMA==d8b9dc69b582e4b67e7bd7c161d4075e',
  )
  import { OKTA_OIDC_INITIALIZE } from '@/store/modules/auth/constants'
  import {
    SET_SOURCE_CONSTANTS,
    SET_DATASETS,
    SET_PRIMARY_INSIGHTS_FILTER,
    SET_MVPDS,
    SET_VIDEOAMP_AUDIENCE_LIST
  } from '@/store/modules/applicationResources/constants'
  import { SET_NETWORKS } from '@/appLogic/networks/store/constants'
  import { SET_PERMISSIONS } from '@/appLogic/permissions/store/constants'

  const LOCATION_USER_WOULD_LIKE_TO_GO_TO = 'LOCATION_USER_WOULD_LIKE_TO_GO_TO'
  const LOCATION_BEFORE_REDIRECT_TO_LOGIN = 'AM_LOCATION_BEFORE_REDIRECT_TO_LOGIN'

  const saveLocationBeforeLogin = function () {
    let currentLocation = window.location.href
    localStorage.setItem(LOCATION_BEFORE_REDIRECT_TO_LOGIN, currentLocation)
  }

  const shouldGoToLocation = function (url) {
    /* if the location User Was Trying to Go to is not the following,
     * then we will direct the user there instead of the original place
     * 1. the domain
     * 2. the login
     */
    let x = new URL(url)
    let isLogin = x.hash ? x.hash.includes('login') : false
    let forwardSlashSplitsAfterHash = x.hash ? x.hash.split('/') : []
    let forwardSlashSplits = url.split('/')
    if (isLogin && forwardSlashSplitsAfterHash.length === 2) {
      return false
    }
    // the length of the splits is 5 because https://domain.com/#/ contains 5 forwardslashes.
    // if the user is going to https://domain.com/#/something then something (cell 4 of the splits will contain a value)
    // or there will be more than 5 splits
    let lengthOfFSSplits = forwardSlashSplits.length
    if (lengthOfFSSplits === 5) {
      return forwardSlashSplits[4] !== ''
    } else if (lengthOfFSSplits > 5) {
      return true
    }
  }

  const dispatchUserToLocation = function (username, router) {
    let locationUserWasTryingToGoTo = localStorage.getItem(LOCATION_BEFORE_REDIRECT_TO_LOGIN)
    localStorage.removeItem(LOCATION_BEFORE_REDIRECT_TO_LOGIN)
    if (locationUserWasTryingToGoTo && shouldGoToLocation(locationUserWasTryingToGoTo)) {
      // JAKE TODO still need to test this out
      // to test this, we have to wait 1 hour to get a new authentication somehow
      // then use a url and see if it will
      // 1. login the user
      // 2. redirect the user back to the location the user wanted to go to
      // that is how to test this, but will have to make sure that the authentication is no longer active
      // meaning that isAuthenticated is no longer going to be true...
      const splitAtHashtag = locationUserWasTryingToGoTo.split('/#/')
      router.push({ path: splitAtHashtag[1] }).catch(err => {
        // Ignore NavigationDuplicated error when navigating to the same route
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    } else if (!shouldGoToLocation(window.location.href)) {
      router.push(`/audience-hub/targets/${username}`).catch(err => {
        // Ignore NavigationDuplicated error when navigating to the same route
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    }
  }

  export default {
    name: 'app',
    async beforeCreate() {
      // OKTA INITIALIZATION
      if (this.$auth) {
        await this.$auth.handleLoginRedirect()
        // getting the user info will tell the program that the user has a valid Access Token
        // if it fails, then return false, and redirect the user to log into Audience Matters
        let user = null
        let isAuthenticated = await this.$auth
          .getUser()
          .then(resp => {
            user = resp
            return true
          })
          .catch(resp => false)
        if (isAuthenticated) {
          // so what we need to know is did the user come from the login push?
          this.$store.dispatch(OKTA_OIDC_INITIALIZE, { auth: this.$auth, user })
          await this.$store.dispatch(SET_SOURCE_CONSTANTS)
          this.$store.dispatch(SET_PRIMARY_INSIGHTS_FILTER)
          this.$store.dispatch(SET_DATASETS)
          this.$store.dispatch(SET_NETWORKS)
          this.$store.dispatch(SET_PERMISSIONS)
          this.$store.dispatch(SET_MVPDS)
          this.$store.dispatch(SET_VIDEOAMP_AUDIENCE_LIST)
          dispatchUserToLocation(user.email.toLowerCase(), this.$router)
        } else {
          // redirect the user to the login page
          saveLocationBeforeLogin()
          this.$router.replace({ name: 'login' })
        }
      }
    },
  }
</script>

<style lang="scss">
  // import all external css files needed in app-import in the scss directory
  // TODO all the important and common css can go here
  @import '~scss/app-import';
  @import '../../node_modules/ag-grid-enterprise/dist/styles/ag-grid.css';
  @import '../../node_modules/ag-grid-enterprise/dist/styles/ag-theme-material.css';

  #app {
    min-width: 1024px;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?fa02884c